define('GeoLocation.Service',
  [
    'jQuery',
    'underscore'
  ],
  function (
    jQuery,
    underscore
  ) {
    'use strict';

    var CACHE_KEY = 'uc_geolocation';
    var CACHE_TTL_MS = 24 * 60 * 60 * 1000;

    var cachedLocationPromise = null;

    function getStoredLocation() {
      
      try {
        var storedValue = window.localStorage.getItem(CACHE_KEY);
        if (!storedValue) {
          return null;
        }

        var storedData = JSON.parse(storedValue);

        if (Date.now() - storedData.timestamp > CACHE_TTL_MS) {
          window.localStorage.removeItem(CACHE_KEY);
          return null;
        }

        return { country: storedData.country, isAU: storedData.isAU, isNZ: storedData.isNZ };
      } catch (error) {
        return null;
      }
    }

    function storeLocation(locationData) {
      try {
        window.localStorage.setItem(
          CACHE_KEY,
          JSON.stringify(underscore.extend({ timestamp: Date.now() }, locationData))
        );
      } catch (error) {
        // localStorage may be unavailable in private mode or when quota is exceeded.
      }
    }

    function isCoordinatesInAustralia(latitude, longitude) {
      return latitude <= -10 && latitude >= -44 && longitude >= 112 && longitude <= 154;
    }

    function isCoordinatesInNewZealand(latitude, longitude) {
      return latitude <= -33 && latitude >= -48 && longitude >= 166 && longitude <= 179;
    }

    function buildLocationFromCountryCode(countryCode) {
      return {
        country: countryCode,
        isAU: countryCode === 'AU',
        isNZ: countryCode === 'NZ'
      };
    }

    function isCoordinatesInUruguay(latitude, longitude) {
      return latitude <= -30 && latitude >= -35 && longitude >= -58 && longitude <= -53;
    }

    function buildLocationFromCoordinates(latitude, longitude) {
      if (isCoordinatesInAustralia(latitude, longitude)) {
        return buildLocationFromCountryCode('AU');
      }
      if (isCoordinatesInNewZealand(latitude, longitude)) {
        return buildLocationFromCountryCode('NZ');
      }
      if (isCoordinatesInUruguay(latitude, longitude)) {
        return buildLocationFromCountryCode('NZ');
      }
      return buildLocationFromCountryCode(null);
    }

    function fetchLocationFromGPS() {
      var deferred = jQuery.Deferred();

      if (!navigator.geolocation) {
        deferred.reject();
        return deferred.promise();
      }

      navigator.geolocation.getCurrentPosition(
        function (position) {
          deferred.resolve(buildLocationFromCoordinates(
            position.coords.latitude,
            position.coords.longitude
          ));
        },
        function () {
          deferred.reject();
        },
        { enableHighAccuracy: false, timeout: 10000, maximumAge: 0 }
      );

      return deferred.promise();
    }

    function fetchLocationFromIP() {
      var deferred = jQuery.Deferred();

      jQuery.ajax({
        url: 'https://api.country.is/',
        method: 'GET',
        dataType: 'json',
        timeout: 5000
      })
        .done(function (responseData) {
          var countryCode = responseData && responseData.country ? responseData.country : null;
          deferred.resolve(buildLocationFromCountryCode(countryCode));
        })
        .fail(function () {
          deferred.resolve(buildLocationFromCountryCode(null));
        });

      return deferred.promise();
    }

    var GeoLocationService = {
      getLocation: function () {
        if (cachedLocationPromise) {
          return cachedLocationPromise;
        }

        var deferred = jQuery.Deferred();
        cachedLocationPromise = deferred.promise();

        var storedLocation = getStoredLocation();
        if (storedLocation) {
          deferred.resolve(storedLocation);
          return cachedLocationPromise;
        }

        fetchLocationFromGPS()
          .done(function (locationData) {
            storeLocation(locationData);
            deferred.resolve(locationData);
          })
          .fail(function () {
            fetchLocationFromIP().done(function (locationData) {
              storeLocation(locationData);
              deferred.resolve(locationData);
            });
          });

        return cachedLocationPromise;
      }
    };

    return GeoLocationService;
  }
);
